import { __decorate, __metadata } from "tslib";
import { Component, ModelSync, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvRate";
let LvRate = class LvRate extends UIComponent {
    getIconFillColor(value) {
        if (value <= this.model)
            return this.selectedColor;
        else
            return this.defaultColor;
    }
    setValue(value) {
        this.model = value;
    }
};
__decorate([
    Prop({ type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvRate.prototype, "min", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 5 }),
    __metadata("design:type", Number)
], LvRate.prototype, "max", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 20 }),
    __metadata("design:type", Number)
], LvRate.prototype, "size", void 0);
__decorate([
    Prop({ type: String, required: false, default: "#faa05a" }),
    __metadata("design:type", String)
], LvRate.prototype, "selectedColor", void 0);
__decorate([
    Prop({ type: String, required: false, default: "#e1e2e2" }),
    __metadata("design:type", String)
], LvRate.prototype, "defaultColor", void 0);
__decorate([
    ModelSync("value", "change", { type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvRate.prototype, "model", void 0);
LvRate = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvRate);
export default LvRate;
//# sourceMappingURL=script.js.map